/* ripple+ Quit Kit builder — BFCM copy: identical to quit-kit.js plus the free Pod Case gift line.
   Kept separate so the live Switch Kit page (quit-kit.js) is untouched. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.qkReady === '1') return;
    root.dataset.qkReady = '1';

    var cfgEl = root.querySelector('[data-qk-config]');
    if (!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.pods || !cfg.pods.length) return;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cfg.currency || 'USD', currencyDisplay: 'narrowSymbol'
      });
    } catch (e) {
      try {
        fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD' });
      } catch (e2) {
        fmt = { format: function (n) { return '$' + n.toFixed(2); } };
      }
    }
    function money(cents) { return fmt.format(cents / 100); }

    var defaultTier = 0;
    cfg.tiers.forEach(function (t, i) { if (t.selected) defaultTier = i; });

    var state = {
      tier: defaultTier,
      subscribed: cfg.subscribeByDefault !== false,
      freqName: cfg.plans.length ? cfg.plans[0].name : null,
      qty: {},
      addon: false
    };

    var el = {
      tiers: root.querySelectorAll('[data-qk-tier]'),
      plan: root.querySelector('[data-qk-plan]'),
      toggle: root.querySelector('[data-qk-toggle]'),
      freq: root.querySelector('[data-qk-freq]'),
      pods: root.querySelectorAll('[data-qk-pod]'),
      counter: root.querySelector('[data-qk-counter]'),
      footCount: root.querySelector('[data-qk-foot-count]'),
      footMax: root.querySelectorAll('[data-qk-foot-max]'),
      atc: root.querySelector('[data-qk-atc]'),
      atcText: root.querySelector('[data-qk-atc-text]'),
      trustMid: root.querySelector('[data-qk-trust-mid]'),
      addonBtn: root.querySelector('[data-qk-addon]'),
      error: root.querySelector('[data-qk-error]')
    };

    function tier() { return cfg.tiers[state.tier]; }
    function maxPods() { return tier().pods; }

    function tierDiscount(t) {
      if (typeof t.discount === 'number') return t.discount;
      return cfg.discountPercent || 0;
    }

    /* Resolve the selling plan for a tier: same frequency name, matching discount.
       If no plan carries that discount, fall back to the lowest-discount plan of
       that frequency so the charge is never higher than advertised elsewhere. */
    function planFor(t) {
      var name = (state.freqName || '').toLowerCase();
      var candidates = cfg.plans.filter(function (p) { return p.name.toLowerCase() === name; });
      if (!candidates.length) candidates = cfg.plans.slice();
      var exact = candidates.filter(function (p) { return p.discount === tierDiscount(t); });
      if (exact.length) return exact[0];
      candidates.sort(function (a, b) { return a.discount - b.discount; });
      return candidates[0] || null;
    }

    function podById(id) {
      for (var i = 0; i < cfg.pods.length; i++) if (cfg.pods[i].id === id) return cfg.pods[i];
      return null;
    }

    /* A pod is selectable only if it's in stock, and — when subscribing — only if it
       actually carries the subscription selling plan. */
    function podUsable(pod) {
      if (!pod.available) return false;
      if (state.subscribed && !pod.subscribable) return false;
      return true;
    }

    function chosenCount() {
      var n = 0;
      for (var k in state.qty) n += state.qty[k];
      return n;
    }

    function podsSubtotal() {
      var cents = 0;
      for (var k in state.qty) {
        var p = podById(k);
        if (p) cents += p.price * state.qty[k];
      }
      return cents;
    }

    /* Tier card price uses the base pod price; the ATC total uses what's actually chosen,
       so a differently-priced flavour can never silently under- or over-charge. */
    function tierListPrice(t) { return cfg.basePrice * t.pods; }

    function discounted(cents, pct) {
      if (!state.subscribed || !pct) return cents;
      return Math.round(cents * (100 - pct) / 100);
    }

    /* The free device only comes with a plan, so only then does its price join the
       crossed-out figure. Older configs without the flag keep the pods-only price. */
    function giftValue() {
      if (!state.subscribed) return 0;
      var v = 0;
      if (cfg.device && cfg.device.inWasPrice) v += cfg.device.price || 0;
      if (cfg.gift && cfg.gift.inWasPrice) v += cfg.gift.price || 0;
      return v;
    }

    function clampToTier() {
      var max = maxPods();
      var total = chosenCount();
      if (total <= max) return;
      var keys = Object.keys(state.qty);
      for (var i = keys.length - 1; i >= 0 && total > max; i--) {
        var k = keys[i];
        while (state.qty[k] > 0 && total > max) { state.qty[k]--; total--; }
        if (state.qty[k] === 0) delete state.qty[k];
      }
    }

    /* BFCM: changing kit always lands on exactly that kit's pod count.
       Down: drop doubles first, then single flavours from the end.
       Up: add the starred default flavours not chosen yet, then one more of each chosen flavour in turn.
       From the defaults this gives the Figma states (Starter 1/1/1, Committed 2/2/1/1). */
    function fitToTier() {
      var max = maxPods();
      var total = chosenCount();
      var order = cfg.pods.map(function (p) { return p.id; });
      while (total > max) {
        var chosen = order.filter(function (id) { return state.qty[id]; });
        var pick = null;
        for (var i = chosen.length - 1; i >= 0; i--) if (state.qty[chosen[i]] > 1) { pick = chosen[i]; break; }
        if (!pick) pick = chosen[chosen.length - 1];
        if (!pick) break;
        state.qty[pick]--;
        if (!state.qty[pick]) delete state.qty[pick];
        total--;
      }
      cfg.pods.forEach(function (pod) {
        if (total < max && pod.preselect && podUsable(pod) && !state.qty[pod.id]) { state.qty[pod.id] = 1; total++; }
      });
      var cycle = order.filter(function (id) { var p = podById(id); return state.qty[id] && p && podUsable(p); });
      for (var n = 0; total < max && cycle.length && n < 100; n++) {
        state.qty[cycle[n % cycle.length]]++;
        total++;
      }
    }

    function dropUnusablePods() {
      Object.keys(state.qty).forEach(function (k) {
        var p = podById(k);
        if (!p || !podUsable(p)) delete state.qty[k];
      });
    }

    function render() {
      var max = maxPods();
      var count = chosenCount();

      /* tiers */
      Array.prototype.forEach.call(el.tiers, function (node, i) {
        var t = cfg.tiers[i];
        var list = tierListPrice(t);
        var now = discounted(list, tierDiscount(t));
        node.classList.toggle('is-selected', i === state.tier);
        node.setAttribute('aria-pressed', i === state.tier ? 'true' : 'false');
        var was = node.querySelector('[data-qk-tier-was]');
        var nowEl = node.querySelector('[data-qk-tier-now]');
        var each = node.querySelector('[data-qk-tier-each]');
        if (was) was.textContent = state.subscribed ? money(list + giftValue()) : '';
        if (nowEl) nowEl.textContent = money(now);
        if (each) each.textContent = money(Math.round(now / t.pods)) + ' ' + (cfg.text.perPod || 'per pod pack');
      });

      /* plan */
      var strongEl = root.querySelector('[data-qk-plan-strong]');
      if (strongEl && cfg.text.planTitleTpl) {
        strongEl.textContent = cfg.text.planTitleTpl.replace('[pct]', tierDiscount(tier()));
      }
      if (el.plan) el.plan.classList.toggle('is-off', !state.subscribed);
      if (el.toggle) el.toggle.setAttribute('aria-checked', state.subscribed ? 'true' : 'false');
      if (el.freq) el.freq.disabled = !state.subscribed;

      /* pods */
      Array.prototype.forEach.call(el.pods, function (node) {
        var id = node.getAttribute('data-qk-pod');
        var pod = podById(id);
        if (!pod) return;
        var usable = podUsable(pod);
        var qty = state.qty[id] || 0;
        node.classList.toggle('is-active', qty > 0);
        node.classList.toggle('is-disabled', !usable);

        var minus = node.querySelector('[data-qk-minus]');
        var plus = node.querySelector('[data-qk-plus]');
        var qtyEl = node.querySelector('[data-qk-qty]');
        var note = node.querySelector('[data-qk-pod-note]');

        if (qtyEl) qtyEl.textContent = qty;
        if (minus) minus.hidden = qty === 0;
        if (qtyEl) qtyEl.hidden = qty === 0;
        if (plus) plus.disabled = !usable || count >= max;

        if (note) {
          if (!pod.available) note.textContent = cfg.text.soldOut;
          else if (state.subscribed && !pod.subscribable) note.textContent = cfg.text.noPlan;
          else note.textContent = '';
        }
      });

      /* counters */
      if (el.counter) {
        /* Falls back to the old hard-coded wording if an older config is cached. */
        el.counter.textContent = cfg.text.counter
          ? cfg.text.counter.replace('[n]', count).replace('[max]', max)
          : count + ' of ' + max + ' pods chosen';
      }
      if (el.footCount) el.footCount.textContent = count + ' of ' + max;
      Array.prototype.forEach.call(el.footMax, function (n) { n.textContent = max; });

      /* atc */
      var subtotal = podsSubtotal();
      var total = discounted(subtotal, tierDiscount(tier()));
      if (state.addon && cfg.addon) total += cfg.addon.price;
      var complete = count === max;

      if (el.atc) el.atc.disabled = !complete;
      if (el.atcText) {
        if (!complete) {
          var left = max - count;
          el.atcText.textContent = cfg.text.selectMore
            .replace('[n]', left)
            .replace('[s]', left === 1 ? '' : 's')
            .replace('[S]', left === 1 ? '' : 'S');
        } else if (state.subscribed && (tierDiscount(tier()) || giftValue())) {
          var was = subtotal + (state.addon && cfg.addon ? cfg.addon.price : 0) + giftValue();
          el.atcText.innerHTML = cfg.text.addToCart + ' | <span class="qk__atc-was">' + money(was) + '</span>' + money(total);
        } else {
          el.atcText.textContent = cfg.text.addToCart + ' | ' + money(total);
        }
      }

      if (el.trustMid) el.trustMid.textContent = state.subscribed ? cfg.text.trustSubscribed : cfg.text.trustOneTime;
      if (el.addonBtn) {
        el.addonBtn.classList.toggle('is-added', state.addon);
        el.addonBtn.textContent = (state.addon ? cfg.text.addonAdded : cfg.text.addonAdd) + ' | ' + money(cfg.addon ? cfg.addon.price : 0);
      }
    }

    function showError(msg) {
      if (!el.error) return;
      el.error.textContent = msg;
      el.error.classList.add('is-visible');
    }
    function clearError() {
      if (el.error) el.error.classList.remove('is-visible');
    }

    /* Each tier can pin its own delivery cadence. Only switch when that exact
       frequency exists in the picker, so a renamed Skio plan cannot strand it. */
    function applyTierFrequency() {
      var t = cfg.tiers[state.tier];
      var want = t && t.freq;
      if (!want || !el.freq) return;
      var match = null;
      Array.prototype.forEach.call(el.freq.options, function (o) {
        if (o.value.toLowerCase() === String(want).toLowerCase()) match = o.value;
      });
      if (!match) return;
      el.freq.value = match;
      state.freqName = match;
    }

    /* ---------- events ---------- */
    Array.prototype.forEach.call(el.tiers, function (node, i) {
      node.addEventListener('click', function () {
        state.tier = i;
        applyTierFrequency();
        fitToTier();
        clearError();
        render();
      });
    });

    if (el.toggle) {
      el.toggle.addEventListener('click', function () {
        state.subscribed = !state.subscribed;
        dropUnusablePods();
        clearError();
        render();
      });
    }

    if (el.freq) {
      el.freq.addEventListener('change', function () {
        state.freqName = el.freq.value || null;
      });
      if (el.freq.value) state.freqName = el.freq.value;
    }

    applyTierFrequency();

    Array.prototype.forEach.call(el.pods, function (node) {
      var id = node.getAttribute('data-qk-pod');
      var minus = node.querySelector('[data-qk-minus]');
      var plus = node.querySelector('[data-qk-plus]');

      if (plus) plus.addEventListener('click', function () {
        var pod = podById(id);
        if (!pod || !podUsable(pod)) return;
        if (chosenCount() >= maxPods()) return;
        state.qty[id] = (state.qty[id] || 0) + 1;
        clearError();
        render();
      });

      if (minus) minus.addEventListener('click', function () {
        if (!state.qty[id]) return;
        state.qty[id]--;
        if (state.qty[id] === 0) delete state.qty[id];
        clearError();
        render();
      });
    });

    if (el.addonBtn) {
      el.addonBtn.addEventListener('click', function () {
        state.addon = !state.addon;
        render();
      });
    }

    /* accordions */
    Array.prototype.forEach.call(root.querySelectorAll('[data-qk-acc]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.qk__acc-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.blur();
      });
    });

    /* ADD ON panel collapses like the other accordions */
    var addonToggle = root.querySelector('[data-qk-addon-toggle]');
    if (addonToggle) {
      addonToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var block = addonToggle.closest('[data-qk-addon-block]');
        if (!block) return;
        var open = block.classList.toggle('is-open');
        addonToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        addonToggle.blur();
      });
    }

    /* read more */
    var rm = root.querySelector('[data-qk-readmore]');
    if (rm) rm.addEventListener('click', function () {
      var d = rm.closest('.qk__desc');
      if (d) d.classList.add('is-open');
      rm.hidden = true;
    });

    /* ---------- media carousel: native swipe, arrows loop, thumbs stay in sync ---------- */
    (function () {
      var track = root.querySelector('[data-qk-track]');
      if (!track) return;
      var slides = [].slice.call(track.querySelectorAll('[data-qk-slide]'));
      var thumbs = [].slice.call(root.querySelectorAll('[data-qk-thumb]'));
      if (!slides.length) return;
      var current = 0;

      function markActive(i) {
        current = i;
        thumbs.forEach(function (t, ti) {
          t.setAttribute('aria-current', ti === i ? 'true' : 'false');
        });
      }

      function idxFromScroll() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (sl, i) {
          var c = sl.offsetLeft - track.offsetLeft + sl.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function goTo(i) {
        /* wrap so next past the end returns to the first slide */
        var n = slides.length;
        var idx = ((i % n) + n) % n;
        var target = slides[idx].offsetLeft - track.offsetLeft;
        markActive(idx);
        track.scrollTo({ left: target, behavior: 'smooth' });
        /* some engines ignore smooth scrollTo entirely — force the jump if nothing moved */
        setTimeout(function () {
          if (Math.abs(track.scrollLeft - target) > 4) {
            track.scrollTo({ left: target, behavior: 'instant' });
          }
        }, 350);
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-qk-thumb'), 10) || 0);
        });
      });

      var prev = root.querySelector('[data-qk-prev]');
      var next = root.querySelector('[data-qk-next]');
      if (prev) prev.addEventListener('click', function () { goTo(idxFromScroll() - 1); });
      if (next) next.addEventListener('click', function () { goTo(idxFromScroll() + 1); });

      /* keep the thumbs honest when the user swipes the track directly.
         Deliberately NOT requestAnimationFrame: if rAF is throttled (background tab,
         reduced motion) the callback never runs, the guard never clears and every
         later scroll is silently dropped. */
      function syncFromScroll() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (sl, i) {
          var c = sl.offsetLeft - track.offsetLeft + sl.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== current) markActive(best);
      }

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          scrollTimer = null;
          syncFromScroll();
        }, 60);
      }, { passive: true });

      /* Primary tracker. Scroll events proved unreliable on some engines, so the
         active slide is driven by intersection instead — this fires on swipe,
         momentum-settle and programmatic scroll alike. */
      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (entries) {
          var winner = null;
          entries.forEach(function (e) {
            if (!winner || e.intersectionRatio > winner.intersectionRatio) winner = e;
          });
          if (winner && winner.intersectionRatio >= 0.5) {
            var i = slides.indexOf(winner.target);
            if (i > -1 && i !== current) markActive(i);
          }
        }, { root: track, threshold: [0.25, 0.5, 0.75, 0.99] });
        slides.forEach(function (sl) { io.observe(sl); });
      }

      /* belt and braces for touch: re-check once the finger lifts and again after momentum */
      track.addEventListener('touchend', function () {
        setTimeout(syncFromScroll, 80);
        setTimeout(syncFromScroll, 400);
      }, { passive: true });

      markActive(0);
    })();

    /* Open the cart where the shopper already is. An explicit redirect setting still
       wins; otherwise use the theme/Rebuy drawer and only fall back to navigating. */
    function openCart() {
      if (cfg.redirect) { window.location.href = cfg.redirect; return; }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      /* Rebuy Smart Cart drawer */
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }
      } catch (e) {}

      /* theme's own cart trigger — opens the slide-out without leaving the page */
      var trigger = document.querySelector('a.cart-link, [data-cart-toggle], .js-cart-trigger');
      if (trigger) { trigger.click(); return; }

      window.location.href = cfg.routes.cart;   /* last resort */
    }

    /* ---------- add to cart ---------- */
    if (el.atc) {
      el.atc.addEventListener('click', function () {
        if (el.atc.disabled) return;
        clearError();

        var items = [];
        var plan = planFor(tier());
        Object.keys(state.qty).forEach(function (id) {
          var pod = podById(id);
          if (!pod || !state.qty[id]) return;
          var item = { id: pod.variant, quantity: state.qty[id] };
          /* The page sells flavour names (Chamomile) but the products are named
             for their effect (RELAX Pods). Carry the flavour through as a line
             property so cart, checkout and the order all agree with the page. */
          if (pod.title) item.properties = { 'Flavour': pod.title };
          if (state.subscribed && plan && pod.subscribable) item.selling_plan = plan.id;
          items.push(item);
        });

        if (!items.length) { showError(cfg.text.errEmpty); return; }

        /* Free device rides along as a one-time line, so repeat deliveries are pods only.
           The $0 comes from the automatic discount, not from this widget. */
        if (state.subscribed && cfg.device && cfg.device.variant) {
          items.push({
            id: cfg.device.variant,
            quantity: 1,
            properties: { '_qk_plan_gift': 'yes' }
          });
        }

        /* BFCM: the Pod Case rides along free with a plan, like the device. The $0 comes from
           an automatic discount, not from this widget. */
        if (state.subscribed && cfg.gift && cfg.gift.variant) {
          items.push({
            id: cfg.gift.variant,
            quantity: 1,
            properties: { '_bfcm_gift': 'yes' }
          });
        }

        if (state.addon && cfg.addon && cfg.addon.variant) {
          items.push({ id: cfg.addon.variant, quantity: 1 });
        }

        el.atc.classList.add('is-loading');

        fetch(cfg.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || cfg.text.errGeneric);
            el.atc.classList.remove('is-loading');
            openCart();
          })
          .catch(function (err) {
            el.atc.classList.remove('is-loading');
            showError(err.message || cfg.text.errGeneric);
          });
      });
    }

    dropUnusablePods();

    /* Flavours ticked "Pre-select one" start with one each, in block order, until the
       default tier is full. clampToTier trims from the end if a smaller tier is picked. */
    cfg.pods.forEach(function (pod) {
      if (pod.preselect && podUsable(pod) && chosenCount() < maxPods()) state.qty[pod.id] = 1;
    });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qk-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* theme editor re-render */
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-qk-root]'), init);
  });
})();
